import {useState} from 'react'
import OrgPermissionsForm from './OrgPermissionsForm';
import OrgPermissionsList from './OrgPermissionsList';

const OrgPermissions = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <OrgPermissionsForm addForm={setFromIsShown} update={upData} />
        ) : (
          <OrgPermissionsList addForm={setFromIsShown} update={setUpData} />
        )}
  
    </>
  )
}

export default OrgPermissions